import { render, staticRenderFns } from "./passed_term.vue?vue&type=template&id=3fe3063a&"
import script from "./passed_term.vue?vue&type=script&lang=js&"
export * from "./passed_term.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports